import { StyleSheet } from 'react-native';
import {
  borderRadius,
  fontSizeSmall,
  darkGrey,
  darkestGrey,
  textInputBorderStyle,
  textInputBorderWidth,
  fontSizeExtraSmall,
  fontFamilyLight,
  fontFamilyMedium,
} from '../../../constants/palette';

export default StyleSheet.create({
  artistName: {
    padding: 2,
    fontSize: fontSizeSmall,
    fontFamily: fontFamilyMedium,
    width: '80%',
  },

  bottomRow: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  container: {
    borderColor: 'rgba(64,64,64,0.6)',
    backgroundColor: darkestGrey,
    borderRadius,
    borderStyle: textInputBorderStyle,
    borderWidth: textInputBorderWidth,
    flex: 1,
    flexDirection: 'column',
    paddingTop: 0,
    paddingLeft: 10,
    paddingRight: 10,
    paddingBottom: 10,
    width: 300,
    height: 200,
  },

  imageContainer: {
    marginRight: 10,
    marginLeft: 10,
    width: '30%',
  },

  likesBox: {
    backgroundColor: darkGrey,
    borderRadius,
    width: 88,
    height: 80,
    justifyContent: 'center',
    paddingRight: 10,
  },

  likesText: {
    textAlign: 'center',
    textAlignVertical: 'center',
    marginLeft: 10,
  },
  thumbsBox: {
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    paddingBottom: 2,
  },

  resultBox: {
    backgroundColor: darkGrey,
    borderRadius,
    width: 88,
    height: 80,
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 10,
    marginRight: 10,
  },
  switchStyle: {
    marginTop: 10,
  },

  trackDetailsContainer: {
    flexDirection: 'column',
    justifyContent: 'center',
    width: '70%',
  },

  trackTitle: {
    padding: 2,
    fontFamily: fontFamilyLight,
    fontSize: fontSizeExtraSmall,
    width: '80%',
  },
  topRow: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
});
